import Dealroom from "./Dealroom/Dealroom";

export { Dealroom };


// WEBPACK FOOTER //
// ./src/views/Dealroom/index.js